import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/base/BackToTop';
import HeroSection from './components/HeroSection';
import FeaturedReports from './components/FeaturedReports';
import HowToSubmit from './components/HowToSubmit';
import CategoriesSection from './components/CategoriesSection';
import PrinciplesSection from './components/PrinciplesSection';
import FaqSection from './components/FaqSection';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '17爆料投稿之后多久会有回应？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '编辑部通常在收到投稿后1至3个工作日内完成初步审核，并通过你预留的联系方式与你取得联系。匿名投稿无法逐一回复，但每条线索都会被认真阅读。',
      },
    },
    {
      '@type': 'Question',
      name: '我可以匿名投稿吗？投稿信息会保密吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '可以完全匿名。17爆料支持匿名提交，平台承诺对所有投稿人信息严格保密，不向任何第三方透露信源。',
      },
    },
    {
      '@type': 'Question',
      name: '什么类型的线索会被核实发布？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们优先关注具有公共利益价值的线索，包括消费维权、食品安全、物业纠纷、交通安全、网络诈骗、社会民生和行业黑料。',
      },
    },
    {
      '@type': 'Question',
      name: '投稿线索未被发布，是因为什么原因？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '通常因为无法核实关键事实、线索信息不完整、不具备公共利益价值，或类似报道已发布。建议提供更多佐证材料以提高核实成功率。',
      },
    },
    {
      '@type': 'Question',
      name: '17爆料私信渠道和在线投稿有什么区别？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '在线投稿表单支持上传附件，处理效率更高；私信渠道适合先沟通或有特殊情况。两种方式都受到同等保密保护。',
      },
    },
    {
      '@type': 'Question',
      name: '如何知道自己的线索被核实发布了？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '留下联系方式的用户，编辑部会在发布前或发布后通知你。你也可以在「已核实报道」栏目中搜索相关关键词查找相关报道。',
      },
    },
  ],
};

export default function HomePage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedReports />
        <HowToSubmit />
        <CategoriesSection />
        <PrinciplesSection />
        <FaqSection />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}